import { InfoCertificatoVO } from "@app/shared/vo/info-certificatoVO";
import { InfoFirmaVO } from "@app/shared/vo/info-firmaVO";
import { UtenteVO } from "./utenteVO";

export class DatiFirmaVO {
  dataVerifica: number;

  statoVerifica: boolean;

  firmatario: UtenteVO;

  info: InfoFirmaVO[];
}
